import { render, staticRenderFns } from "./CalendarPsychologist.vue?vue&type=template&id=3d3bf263&"
import script from "./CalendarPsychologist.vue?vue&type=script&lang=ts&"
export * from "./CalendarPsychologist.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarPsychologist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports